import { render, staticRenderFns } from "./MobileBookingsListCard.vue?vue&type=template&id=2a0f5e4f&"
import script from "./MobileBookingsListCard.vue?vue&type=script&lang=js&"
export * from "./MobileBookingsListCard.vue?vue&type=script&lang=js&"
import style0 from "./MobileBookingsListCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports